import "./Hero.css";

function Hero() {

    return (

        <section className="hero">

            <div className="hero-left">

                <span className="hero-tag">
                    🔥 Limited Time Offer
                </span>

                <h1>

                    Upgrade Your
                    <span> Shopping Experience</span>

                </h1>

                <p>

                    Discover premium electronics,
                    fashion, furniture and more at
                    unbeatable prices.

                </p>

                <div className="hero-buttons">

                    <button className="shop-btn">

                        Shop Now

                    </button>

                    <button className="explore-btn">

                        Explore

                    </button>

                </div>

            </div>

            <div className="hero-right">

                <div className="floating-card phone">

                    📱

                </div>

                <div className="floating-card laptop">

                    💻

                </div>

                <div className="floating-card watch">

                    ⌚

                </div>

                <div className="floating-card headphone">

                    🎧

                </div>

            </div>

        </section>

    );

}

export default Hero;